import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import Modal from '@common/Modal'
import Preloader from '@UI/Preloader'
import { LeadPaymentLink } from '@/api/types/crm.types'
import { ClassInfoType } from '@pages/Admin/ManageClassSettings/types'
import { classApi, crmApi } from '@/api'
import ClassEnrollmentBody from './components/ClassEnrollmentBody/ClassEnrollmentBody'
import { CloseOutlined } from '@ant-design/icons'
import { Empty } from 'antd'

interface IClassEnrollmentModal {
  visible: boolean
  classId?: number
  classLinkId?: number
  userId?: number
  onDismiss: () => void
  onSuccess: () => void
}

const ClassEnrollmentModal: FC<IClassEnrollmentModal> = ({
  visible,
  classId,
  classLinkId,
  userId,
  onSuccess = () => {},
  onDismiss = () => {},
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [classData, setClassData] = useState<ClassInfoType | null>(null)
  const [classLinkData, setClassLinkData] = useState<LeadPaymentLink | null>(
    null,
  )
  const classState = classData ?? classLinkData?.class

  const fetchSettings = async () => {
    setIsLoading(true)
    try {
      if (classLinkId) {
        const classLink = (await crmApi.getLeadPaymentLink(classLinkId!)).data
          .data
        setClassLinkData(classLink)
      } else if (classId) {
        const classData = (await classApi.show(classId)).data.data
        setClassData(classData)
      }
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [visible])

  return (
    <Modal
      active={visible}
      setActive={onDismiss}
      // @ts-ignore
      className={cn.modalWrapper}
    >
      <div className={cn.modalContainer}>
        <div className={cn.modalHeader}>
          <span className={cn.modalHeaderTitle}>{classState?.title}</span>
          <CloseOutlined
            className={cn.closeIcon}
            onClick={onDismiss}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </div>
        {isLoading ? (
          <div className={cn.preloader}>
            <Preloader />
          </div>
        ) : !classState && !isLoading ? (
          <div className={cn.stub}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Такого класса нет'}
            />
          </div>
        ) : (
          <ClassEnrollmentBody
            classData={classData}
            classLinkData={classLinkData}
            userId={userId}
            onSuccess={onSuccess}
          />
        )}
      </div>
    </Modal>
  )
}

export default ClassEnrollmentModal
